import { gql } from "@apollo/client";

export const GET_LOGITIX_AUDIT_LOGS = gql`
query LogitixAuditLogs ( $limit: Int = 100, $offset: Int = 0) {
 logitix_audit_logs(order_by: {lg_updated_at: desc},limit: $limit, offset: $offset) {
    Action
    api_type
    lg_created_at
    lg_deleted_at
    lg_id
    lg_updated_at
    old_listing_price
    row
    seat
    section
    status
    updated_listing_price
    venue
    user {
      u_full_name
      u_first_name
      u_last_name
      u_id
      u_email_id
      u_original_email
    }
    event {
      e_name
      e_id
    }
    league {
      l_name
      l_id
    }
    ticket_placement {
      tp_id
      ticket {
        user {
          u_full_name
          u_first_name
          u_last_name
          u_id
          u_email_id
          u_original_email
        }
      }
    }
  }
}
`;